export default "__VITE_ASSET__5WZRIFVZ__"